export enum EntriesTableMainFields {
  EMAIL = "email",
  PHONE = "phone",
}
